module.exports = __webpack_public_path__ + "static/media/moneymonk.54c47e07.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/moneymonk.webp
// module id = 913
// module chunks = 0